import { render } from "./ag-computer-select.vue?vue&type=template&id=4879a7f2"
import script from "./ag-computer-select.vue?vue&type=script&lang=js"
export * from "./ag-computer-select.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__